import React, { useState } from "react";
import Header from "../Header";
import SideBar from "../Sidebar";
import WideCard from "../../components/WideCard";
import "./styles.scss";

interface MainLayoutProps {
    children: JSX.Element | JSX.Element[];
    isBurgerHidden?: boolean;
    autoWrapWideCard?: boolean; // タブレット以上のサイズでコンテンツを白カードで囲むかどうか。基本的に各ページの責務のため新規ページではfalse
}

const HEADER_HEIGHT = 60;

export const MainLayout = (props: MainLayoutProps): JSX.Element => {
    const [isSidebarOpen, setSidebarOpen] = useState(false);
    const autoWrapWideCard =
        props.autoWrapWideCard === undefined ? true : props.autoWrapWideCard;
    return (
        <>
            <div className="main-layout">
                <div
                    style={{ height: HEADER_HEIGHT }}
                    className="header-wrapper"
                >
                    <Header
                        onClickBurger={() => setSidebarOpen(!isSidebarOpen)}
                        isBurgerOpen={isSidebarOpen}
                        isBurgerHidden={!!props.isBurgerHidden}
                    />
                </div>
                <div
                    style={{
                        marginTop: HEADER_HEIGHT + "px"
                    }}
                    className="content"
                >
                    <div className="inner-content">
                        {autoWrapWideCard ? (
                            <WideCard>{props.children}</WideCard>
                        ) : (
                            <>{props.children}</>
                        )}
                    </div>
                </div>
            </div>
            {isSidebarOpen && (
                <div
                    className="overlay"
                    onClick={() => setSidebarOpen(false)}
                />
            )}
            <SideBar isSidebarOpen={isSidebarOpen} />
        </>
    );
};
